const isIOS = () =>
	['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform);

export const MAX_MOBILE_WIDTH = 991; // in px
export const MIN_DESKTOP_WIDTH = 992; // in px
export const IS_TABLET = window.matchMedia('(min-width: 768px)').matches;
export const IS_DESKTOP = window.matchMedia(`(min-width: ${MIN_DESKTOP_WIDTH}px)`).matches;
export const IS_TOUCH_DEVICE = 'ontouchstart' in window; // Only add functionality on desktop devices
export const DEFAULT_EASING = [0.65, 0, 0.35, 1];
export const IS_IOS = isIOS();
